import {action, makeAutoObservable} from "mobx"
import EntityCompare from "../../store/entities/EntityCompare"
import ValuesCompareApi from "../../api/ValuesCompareApi"
import Attribute from "../../store/entities/Attribute"
import {noticeController} from "../../utils/NoticeController"


interface FeatureAndAttributePair {
    attribute_id: number
    attributeName: string
    entitiesName: string
}

interface FeatureAndAttributePairWithValuesPairs extends FeatureAndAttributePair {
    entities: EntityCompare[]
}

class EntityCompareController {
    entities: FeatureAndAttributePairWithValuesPairs[] = []
    private _attribute_id: number | undefined

    constructor() {
        makeAutoObservable(this)
    }

    private _attribute: Attribute | undefined

    get attribute(): Attribute | undefined {
        return this._attribute
    }

    private _attribute_name: string | undefined

    get attribute_name(): string | undefined {
        return this._attribute_name
    }


    _entitiesLoaded: boolean = false

    get entitiesLoaded(): boolean {
        return this._entitiesLoaded
    }

    private _name: string | undefined

    get name(): string | undefined {
        return this._name
    }

    private _category_id: number | undefined

    get category_id(): number | undefined {
        return this._category_id
    }

    loadFeatureAndAttributePairs(data?: { category_id: string, attribute_id: string }) {
        if (data) {
            this._category_id = +data.category_id
            this._attribute_id = +data.attribute_id
        }

        ValuesCompareApi.get(data).then(
            action("valuesPairsLoaded", (result) => {
                const data = result.data.data.data
                this._name = result.data.data.name
                this._attribute_name = result.data.data.attribute_name

                const entities = [{
                    attribute_id: data.attribute_id,
                    attributeName: data.ozonAttributeName,
                    entitiesName: data.entitiesName,
                }]
                
                this._entitiesLoaded = true
                this.entities = []
                this.loadEntities(entities)
            }))
    }

    loadEntities(featurePairs: FeatureAndAttributePair[]) {
        for (const featurePair of featurePairs) {
            ValuesCompareApi.getValuePairs(+featurePair.attribute_id, this._category_id)
                .then(
                    action("entitiesByFeaturePairsLoaded", (result) => {
                        const feature = result.data.data
                        const entities: EntityCompare[] = []

                        for (const value of feature.values) {
                            const entity = new EntityCompare(+value.feature_value_id, value.feature_value, featurePair.attribute_id, this._category_id as number, feature.type)
                            if (value.dictionary_value) {
                                entity.value_pair_id = parseInt(value.dictionary_value.id)
                                entity.setDefaultOption({
                                    value: value.dictionary_value.dictionary_id,
                                    label: value.dictionary_value.dictionary_value
                                })
                            }
                            entities.push(entity)
                        }
                        this.entities.push({
                            ...featurePair,
                            entities: entities
                        })
                    }))
        }
    }

    updateEntities() {
        if (this._category_id && this._attribute_id) {
            this.loadFeatureAndAttributePairs({
                category_id: this._category_id.toString(),
                attribute_id: this._attribute_id.toString()
            })
        }
    }

    saveEntities() {
        const data = []
        for (const entity of this.entities) {
            for (const item of entity.entities){
                if(item.dictionary_id !== undefined && this._category_id && this._attribute_id) {
                    data.push({
                        id: item.value_pair_id,
                        dictionary_id: item.dictionary_id,
                        feature_value_type: item.feature_type,
                        feature_value_id: item.feature_value_id,
                        ozon_attribute_id: this._attribute_id,
                        ozon_category_id: this._category_id,
                    })
                }
            }
        }
        ValuesCompareApi.saveEntities(data).then(result=>{
            this.loadFeatureAndAttributePairs({category_id:String(this.category_id), attribute_id:String(this._attribute_id)})
            noticeController.success = ['Сохранено']
            setTimeout(()=>noticeController.clearSuccess(), 1000)
        })

    }
}

const entityCompareController = new EntityCompareController()
export default entityCompareController